var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"filename",attrs:{"title":_vm.title,"href":_vm.link}},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }